import { toObservable } from '@angular/core/rxjs-interop';
import { Injectable, signal } from '@angular/core';

import { uuid } from '../functions';

@Injectable({ providedIn: 'root' })
export class UserSessionService {
	private _sessionID = signal(uuid())

	sessionID = this._sessionID.asReadonly()
	sessionID$ = toObservable(this._sessionID)
}
